import React, {useEffect} from 'react';
import { useWizard } from 'react-use-wizard';
import TimeframeSelection from "../../../components/Common/TimeframeSelection";
import ProjectReports from "../../../components/Project/ProjectReports";
import WizardProgress from "./WizardProgress";
import WizardStepWrapper from "./WizardStepWrapper";
import { withTranslation } from 'react-i18next';

const WizardFormSection = ({ children }) => (
    <div className="mb-1">
        <div className="d-flex flex-column gap-3">
            {children}
        </div>
    </div>
);

const ProjectStep3 = (props) => {
    const { previousStep } = useWizard();
    const { t, stepLabels } = props;

    useEffect(() => {
        const defaultTabKey = props.projects[0]?.type;
        if (defaultTabKey) {
            props.resetSelectAllCheckStatus("HISTORICAL", defaultTabKey);
        }
    }, []);

    return (
        <WizardStepWrapper>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-12 col-lg-12">
                        <WizardProgress labels={stepLabels} className="mb-4"/>

                        <h5 className="text-center wizard-subtitle mb-3">
                            {t('project:historicalTitle')}
                        </h5>

                        <WizardFormSection>
                            <TimeframeSelection
                                filterType="Historical"
                                timeFilter={props.timeFilter}
                                handleTimeFilterUpdate={props.handleTimeFilterUpdate}
                                context="project"
                                absoluteStartError={props.absoluteStartError}
                                absoluteEndError={props.absoluteEndError}
                                benchmarkError={props.benchmarkError}
                            />
                        </WizardFormSection>

                        <WizardFormSection>
                            <ProjectReports
                                reportType="HISTORICAL"
                                projects={props.projects}
                                handleProjectReportsUpdate={props.handleProjectReportsUpdate}
                                selectAllHandler={props.selectAllHandler}
                                isSelectAllChecked={props.isSelectAllChecked}
                                resetSelectAllCheckStatus={props.resetSelectAllCheckStatus}
                                trans={t}
                            />
                        </WizardFormSection>

                        <div className="d-flex justify-content-center gap-3">
                            <button className="btn btn-secondary" onClick={previousStep}>
                                {t('common:back')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </WizardStepWrapper>
    );
};

export default withTranslation()(ProjectStep3);